import { getField, updateField } from 'vuex-map-fields'

const getDefaultFilter = () => ({
  page: 1,
  offset: 0,
  limit: 10,
  perPage: 10,
  sort: '-DC',
  search: '', // Recherche
  datePublicationGt: null,
  datePublicationLt: null,
  preset: 'allPosts'
})

const getPresetFilters = () => ({
  preset: 'allPosts'
})

export default {
  namespaced: true,
  state: {
    tabs: [],
    filter: getDefaultFilter(),
    results: { total: -1, list: [] }, // Stockage des derniers résultats pour accélérer le retour arrière
    currentTab: 'Annonces',
    view: 'list'
  },
  getters: {
    getPostField (state) {
      return getField(state.post)
    },
    getRefreshProgramme (state) {
      return state.refreshProgramme
    },
    getCurrentTab (state) {
      return state.currentTab
    },
    getView: (state) => state.view,
    isListView: (state) => state.view === 'list',
    isCardList: (state) => state.view === 'sticker'
  },
  mutations: {
    updatePostField (state, field) {
      updateField(state.post, field)
    },
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1 }
    },
    setPortalCodes (state, portalCodes) {
      state.filter = { ...state.filter }
    },
    addFilter (state, filter) {
      state.filter = { ...state.filter, ...filter, page: 1 }
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    },
    setCurrentTab (state, currentTab) {
      state.currentTab = currentTab
    },
    setRefreshProgramme (state, refreshProgramme) {
      state.refreshProgramme = refreshProgramme
    },
    setView (state, newView) {
      state.view = newView
    }
  }
}
